import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

export interface AccessLevel {
  id: number;
  client_id: number;
  name: string;
  description: string | null;
  is_default: boolean;
  client_name?: string;
  created_at: string;
  updated_at: string;
}

export interface AccessLevelModulePermission {
  module_id: number;
  module_title: string;
  module_name: string;
  parent_id: number | null;
  max_permission: number;
  permission: number;
}

export interface AccessLevelModuleUpdate {
  module_id: number;
  permission: number;
}

export interface AccessLevelInput {
  name: string;
  description?: string | null;
  is_default: boolean;
  modules?: AccessLevelModuleUpdate[];
}

export const accessLevelService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<DefaultResponse<AccessLevel>>(
      "/access_levels",
      {
        params: {
          page,
          per_page,
          search,
          ...filters,
        },
      },
    );
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<DefaultResponse<AccessLevel, false>>(
      `/access_levels/${id}`,
    );
    return response.data;
  },

  async create(data: AccessLevelInput) {
    const response = await api.post<DefaultResponse<AccessLevel, false>>(
      "/access_levels",
      data,
    );
    return response.data;
  },

  async update(id: number, data: AccessLevelInput) {
    const response = await api.put<DefaultResponse<AccessLevel, false>>(
      `/access_levels/${id}`,
      data,
    );
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete(`/access_levels/${id}`);
    return response.data;
  },

  async getModules(accessLevelId: number, platformId?: number) {
    const response = await api.get<
      DefaultResponse<AccessLevelModulePermission>
    >(`/access_levels/${accessLevelId}/modules`, {
      params: { platform_id: platformId },
    });
    return response.data;
  },
};
